<template>
  <ul class="mdc-form-field client-list">
    <SelectOutstandingSubscriptionInvoiceToPayListItem v-for="client in outstandingSubscriptionInvoices" v-if="client.outstandingInvoice.id" :key="client.clientId" :client="client" />
  </ul>      
</template>
<script>
import { formatMoney } from "&/helpers.js";
import { mapGetters } from 'vuex';

import SelectOutstandingSubscriptionInvoiceToPayListItem from './SelectOutstandingSubscriptionInvoiceToPayListItem';



export default {
  name: 'SelectOutstandingSubscriptionInvoiceToPayList',
  data() {
    return {
      
    };
  },

  computed: {
    ...mapGetters(['outstandingSubscriptionInvoices']),

    totalOutstanding() {
      let value = 0;

      for (let key in this.outstandingSubscriptionInvoices ) {
        value += parseInt(this.outstandingSubscriptionInvoices[key].outstandingInvoice.amount_due)
      }

      return value;
    },

    totalOutstandingFormatted() {
      return this.formatMoney(this.totalOutstanding);
    },

    selectedInvoicesToPay : {
      get(){
        return this.$store.getters.selectedInvoicesToPay
      },
      set(value){
        return this.$store.commit('UPDATED_SELECTED_OUTSTANDING_INVOICES', value)
      }
    }
  },

  methods: {
    formatMoney(value) {
      return formatMoney(value);
    }
  },

  async created() {
    await this.$store.dispatch('GET_OUTSTANDING_SUBSCRIPTION_INVOICES');

    for (let key in this.outstandingSubscriptionInvoices ) {
      this.selectedInvoicesToPay.push(this.outstandingSubscriptionInvoices[key]);
    }
    
  },

  components: {
   SelectOutstandingSubscriptionInvoiceToPayListItem
  }
};
</script>

<style lang="scss" scoped>

.client-list {
  display: grid
}

li {
  list-style: none;
  width: 100%;

  label {
    display: grid;
    grid-template-columns: 6fr 2fr;  
  }

}



.client-name {

}


</style>
